export default {
  en: {
    buttons: {
      sign_in: 'Sign in',
      sign_in_with_google: 'Sign in with Google',
      request: 'Send recovery email',
      next: 'Next',
      previous: 'Previous',
      finish: 'Finish',
      done: 'Great!',
      save: 'Save',
      confirm: 'Confirm',
      cancel: 'Cancel',
      enable_authenticator: 'Enable authenticator',
      authenticate: 'Authenticate',
      start_review: 'Start full review now',
      change_password: 'Change password',
      configure_2fa: 'Configure 2FA',
      submit: 'Submit',
      back: 'Back',
      continue: 'Continue',
      actions: 'Actions',
      edit: 'Edit',
      delete: 'Delete',
      close: 'Close',
      showMore: 'Show more',
      hideMore: 'Hide more',
      moveUp: 'Move up',
      moveDown: 'Move down',
      print: 'Print',
      download: 'Download',
    },
    links: {
      forgot_password: 'Forgot your password?',
      sign_up: 'Sign up',
      sign_in: 'Sign in',
      resend_confirm: 'Resend verification code',
      reset_your_password: 'reset your password',
      problems: 'Problems logging in? Contact us',
      single_sign_on: 'Sign in with SAML SSO',
      here: 'here',
    },
    placeholders: {
      twoFACode: 'Enter code...',
      emailCode: 'Enter email verification code...',
      email: 'Enter email...',
      password: 'Enter password...',
      confirm_password: 'Confirm password...',
    },
    titles: {
      log_in: 'Log in to Risk Ledger',
      forgot_password: 'Forgot your password?',
      reset_password: 'Reset your password',
      mfa: 'Enter your verification code',
      welcome: 'Welcome to Risk Ledger!',
      org_reg: 'Organisation registration',
      org_lead_reg: 'Organisation Lead user registration',
      org_agreement: 'Organisational agreements',
      user_agreement: 'User agreements',
      user_notification_agreement: 'Email notifications',
      confirm_signup: 'Confirm your email address',
      registered_address: 'Registered office address',
    },
    labels: {
      i_agree: 'Yes, I agree',
      receive_email_notifications: 'Receive notification emails',
      reset_password_help: 'Check your email inbox for your reset code.',
      mfa_help: 'This will be sent via an SMS message or found in your authenticator app',
      new_password: 'New password',
      confirm_password: 'Confirm password',
      twoFACode: 'Enter 6 digit code',
      emailCode: 'Verification code',
      legal_name: 'Company legal name',
      country: 'Country',
      company_no: 'Company registration number',
      trading_names: 'Trading names',
      street_address: 'Street address',
      city: 'City',
      postcode: 'Postcode/ZIP code',
      industry: 'Industry/sector',
      web_address: 'Web address',
      business_phone_number: 'Business phone number',
      mobile: 'Mobile number',
      email: 'Email address',
      name: 'Name',
      firstName: 'First name',
      lastName: 'Last name',
      password: 'Password',
      team: 'Team',
      jobTitle: 'Job title',
      or: 'Or',
    },
    help: {
      welcome: 'Welcome!',
      legal_name: 'Insert the legal name your organisation is registered under.',
      country: 'Select the country your organisation is legally registered in.',
      company_no: 'Your legally registered company identification number, if applicable.',
      trading_names:
        'Insert any other names that your company is known by, pressing enter after each.',
      street_address: "Insert your company's registered address.",
      web_address: "Insert your company's website address.",
      business_phone_number: 'The number we can use to contact your company.',
      phone: 'We will be using this number for recovery purposes',
      team: 'Select the team that best describes your role.',
      requiredRef: '* required',
    },
    errors: {
      API_ERROR: 'There was an error performing that request',
      network_error: 'Unable to connect. Check your connectivity or try a different network.',
      org_exists_title:
        "Your organisation already has an account on Risk Ledger, so you won't need to create another one.",
      org_exists_subtitle:
        'Reach out to {email} or {intercom} to get access rather than create a new account.',
      user_exists_title:
        "A user with this email already has an account on Risk Ledger, so you won't need to create another one.",
      user_exists_subtitle:
        'Reach out to {email} or {intercom} to get access rather than create a new account.',
      inviteRedeemed:
        'This invite was sent to multiple contacts in your organisation, and has already been accepted by a colleague. Reach out to {email} or {intercom} to get access rather than create a new account.',
      clickHere: 'click here',
      not_authorized_exception:
        'Your session has expired. Close all other Risk Ledger tabs/windows, refresh this page, and log in again.',
      invalid_code_exception: 'Your code is invalid. Please try again.',
      no_google_oauth_url:
        'Failed to start Google sign-in. Please try again or contact our support team.',
      account_locked:
        'Your account has been locked. Contact your team lead or a Customer Success Manager to unlock your account.',
      // Snake_case to match the `?error=<code>` convention the login page reads
      // from the query string (see account_locked above); the camelCase
      // sessionExpired below is a separate, directly-referenced string.
      session_expired: 'Your session has expired. Please log in again.',
      sessionExpired: 'Your session expired.',
      loginSessionExpired: 'Your sign-in session has expired. Please log in again.',
      missingLoginSession: 'Missing login session. Please sign in again.',
      networkWarning:
        "We've detected a problem between our servers and your browser which will affect your ability to sign up.",
    },
    validation: {
      required: 'Enter valid information',
      phone: 'Enter a valid telephone number',
      select: 'Select an option',
      email: 'Enter a valid email address',
      toggle: 'You must agree to this',
      tag: 'Enter at least one tag',
      textarea: 'Enter some text',
      password_match: 'Passwords must match',
      legalNameRequired: "Enter your company's legal name",
      countryRequired: 'Select a country',
      streetAddressRequired: 'Enter a street address',
      cityRequired: 'Enter a city',
      postcodeRequired: 'Enter a postcode or ZIP code',
      industryRequired: 'Select an industry or sector',
      webAddressRequired: 'Enter a web address',
      businessPhoneRequired: 'Enter a business phone number',
      emailRequired: 'Enter your email address',
      firstNameRequired: 'Enter your first name',
      lastNameRequired: 'Enter your last name',
      mobileRequired: 'Enter your mobile number',
      teamRequired: 'Select your team',
      passwordRequired: 'Enter a password',
      newPasswordRequired: 'Enter a new password',
      confirmPasswordRequired: 'Confirm your password',
      verificationCodeRequired: 'Enter your verification code',
      resetCodeRequired: 'Enter your reset code',
    },
    copy: {
      org_signup_1_1:
        'To get started, let us know the details of the organisation you are registering.',
      org_signup_1_2:
        'For help at any point, contact us at <a href="mailto: support{\'@\'}riskledger.com" target="_blank">support{\'@\'}riskledger.com</a>, chat to us on Intercom, or visit our <a href="https://help.riskledger.com" target="_blank">help centre</a>.',
      org_signup_already_user: 'Already registered? Sign in here.',
      org_signup_2_1:
        'Enter your details below, you can add as many users as you need to complete your profile once you have created your account.',
      org_signup_2_2:
        'You can find out more on our <a href="https://help.riskledger.com" target="_blank">help centre</a>.',
      org_signup_invite: '{0} has invited you to join Risk Ledger!',
      org_signup_invite_accepted: 'This invite from {0} has already been accepted.',
      org_signup_invite_expired:
        'This invite from {0} has expired, but you can still sign up below.',
      org_signup_invite_cancelled:
        '{0} has cancelled this invite, but you can still sign up below.',
      user_signup_1_2: 'Complete your registration below to get started.',
      org_agreement: 'Do you agree, on behalf of {0} ',
      org_agreement_2:
        'to our <a href="https://www.riskledger.com/terms" target="_blank">Terms of Service</a> for organisations?',
      user_agreement:
        'Do you agree to our <a href="https://www.riskledger.com/terms" target="_blank">Terms of Service</a> and <a href="https://www.riskledger.com/privacy" target="_blank">Privacy Policy</a> for users?',
      user_notification_agreement:
        "We send notifications to keep you up to date with important events related to your organisation's security and assurance. We recommend receiving these alerts, but you can always turn them off in your settings later.",
      contact_agreement: 'Do you agree to receive marketing emails from Risk Ledger?',
      confirm_resent: "If this email can receive a verification code, we've sent a new one",
      confirm_existing_account:
        "Already have a Risk Ledger account with this email? We won't send it a code. {signIn} or {resetPassword} instead.",
      emailVerification:
        "To verify the email address that you've provided, enter the verification code from your email below.\n\nThis can sometimes go through to your junk folder, but if you're having issues receiving this, reach out to {email} or {intercom} to open the chat.",
      enter_confirm: "If {0} can receive a verification code, we've sent one there",
      enter_sms: 'Enter the code from the SMS that has just been sent to you',
      enter_authenticator: 'Enter the code from the authenticator app on your device',
      supplier: 'Supplier',
      client: 'Client',
      twofa_is_authenticator_1: 'You currently have 2FA configured with an authenticator app.',
      twofa_is_authenticator_2: 'If you prefer to use SMS instead, you can switch to it below.',
      twofa_is_sms_1:
        'You currently have 2FA configured with SMS. We recommend using an authenticator app, which you can switch to below.',
      getting_started: 'Getting started',
      getting_started_learn_more: 'Learn more about Risk Ledger',
      supplier_client_choice_title: 'Get started as a supplier or client?',
      supplier_client_choice_description:
        'Select whether you want to get started as a supplier or client on the Risk Ledger platform',
      supplier_only_choice_title: 'Get started as a supplier',
      supplier_only_choice_description: 'Get started as a supplier on the Risk Ledger platform',
      supplier_description:
        'As a supplier, you can manage your security, complete your assessment and share with your clients.',
      client_description:
        'As a client, you can run a security assurance programme on your suppliers. Our free tier covers up to 5 suppliers. Get in touch for more details.',
      become_supplier_success: 'You are now a supplier',
      become_client_success: 'You are now a client',
      phone_input_1:
        'We want to ensure your information is protected, so we enforce two-factor authentication across all of our users.\nYou can find out more about our two-factor authentication {mfalink}.\n\nPlease provide a valid mobile phone number that your one-time access codes can be sent to.\nYou can change your method of authentication once logged in.',
      implicitTerms:
        'By creating an account, you agree to our <a href="https://www.riskledger.com/terms" target="_blank">Terms of Service</a> and <a href="https://www.riskledger.com/privacy" target="_blank">Privacy Policy</a>.',
    },
    teams: {
      sales: 'Sales',
      security: 'Security',
      compliance: 'Compliance',
      procurement: 'Procurement',
      legal: 'Legal',
      esg: 'ESG',
      it: 'IT',
      executive: 'Executive Team',
      operations: 'Operations',
      other: 'Other',
    },
  },
};
